import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_10470_99055)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_10470_99055"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M5.33301 5.33594H5.33968M1.33301 3.46927L1.33301 6.45228C1.33301 6.7784 1.33301 6.94146 1.36985 7.09491C1.40251 7.23096 1.45638 7.36102 1.52949 7.48032C1.61194 7.61487 1.72724 7.73017 1.95785 7.96077L7.07027 13.0732C7.8623 13.8652 8.25832 14.2612 8.71497 14.4096C9.11666 14.5401 9.54935 14.5401 9.95104 14.4096C10.4077 14.2612 10.8037 13.8652 11.5958 13.0732L13.0703 11.5987C13.8623 10.8066 14.2583 10.4106 14.4067 9.95397C14.5372 9.55228 14.5372 9.11959 14.4067 8.7179C14.2583 8.26125 13.8623 7.86523 13.0703 7.07319L7.95785 1.96078C7.72724 1.73017 7.61194 1.61487 7.47739 1.53242C7.35809 1.45931 7.22803 1.40544 7.09198 1.37278C6.93853 1.33594 6.77547 1.33594 6.44935 1.33594L3.46634 1.33594C2.7196 1.33594 2.34624 1.33594 2.06102 1.48126C1.81014 1.60909 1.60616 1.81307 1.47833 2.06395C1.33301 2.34917 1.33301 2.72253 1.33301 3.46927ZM5.66634 5.33594C5.66634 5.52003 5.5171 5.66927 5.33301 5.66927C5.14891 5.66927 4.99968 5.52003 4.99968 5.33594C4.99968 5.15184 5.14891 5.0026 5.33301 5.0026C5.5171 5.0026 5.66634 5.15184 5.66634 5.33594Z",
    stroke: $props.color,
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1);
}